export default "__VITE_ASSET__D$tE6d1N__"